var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "choice_block sluzebka m-3 p-3" }, [
    _c(
      "div",
      { staticClass: "intro" },
      [
        _c("h1", { staticClass: "pb-4" }, [_vm._v("Інструкції з написання ")]),
        _vm._v(" "),
        _c(
          "b-form",
          {
            on: {
              submit: [
                _vm.onSubmit,
                function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                },
              ],
            },
          },
          [
            _c("err"),
            _vm._v(" "),
            _c("div", { staticClass: "steps" }, [
              _c(
                "div",
                { staticClass: "step" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "1. Виберiть з випадаючого списку організацію",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select_step width-mobile-auto" },
                        [
                          _c("b-form-select", {
                            attrs: {
                              "value-field": "id",
                              "text-field": "small_title",
                              options: _vm.tov_list,
                              required: "",
                            },
                            model: {
                              value: _vm.form.tov_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tov_id", $$v)
                              },
                              expression: "form.tov_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "2. Виберiть з випадаючого списку службу",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select_step width-mobile-auto" },
                        [
                          _c("b-form-select", {
                            attrs: {
                              "value-field": "id",
                              "text-field": "title",
                              disabled: _vm.is_locked_select("service"),
                              options: _vm.service_list,
                              required: "",
                            },
                            model: {
                              value: _vm.form.service_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "service_id", $$v)
                              },
                              expression: "form.service_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          "3. Виберiть з випадаючого списку - питання, щодо якого ініціюється/створюється",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select_step width-mobile-auto" },
                        [
                          _c("b-form-select", {
                            attrs: {
                              "value-field": "template_id",
                              "text-field": "question_title",
                              disabled: _vm.is_lock_question,
                              state: _vm.validation_question,
                              options: _vm.question_list,
                              required: "",
                            },
                            model: {
                              value: _vm.form.question_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "question_id", $$v)
                              },
                              expression: "form.question_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "min_heigh_rec",
                      attrs: { label: "4. Адресат" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "select_step empty_recipient width-mobile-auto",
                        },
                        [
                          _c(
                            "transition",
                            { attrs: { name: "slide-fade", mode: "out-in" } },
                            [
                              _vm.form.recipient_id > 0
                                ? _c("user_block", {
                                    key: "user_block",
                                    staticClass: "shadow-1 border",
                                    attrs: {
                                      user_id: parseInt(this.recipient.user_id),
                                    },
                                  })
                                : _c(
                                    "b-form-invalid-feedback",
                                    {
                                      key: "form_er",
                                      attrs: { state: !_vm.validation_form },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tАдресат підставляеться автоматично.Оберіть організацію, службу, та питання\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg btn-outline-primary waves-effect waves-themed",
                  attrs: { disabled: _vm.validation_form, type: "submit" },
                },
                [
                  _c("span", {
                    staticClass: "fal",
                    class: {
                      "fa-check mr-1": !_vm.validation_form,
                      "fa-exclamation-triangle": _vm.validation_form,
                    },
                  }),
                  _vm._v("\n\t\t\t\t\tПродовжити\n\t\t\t\t"),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }